import { SlotRepository } from '../Repositories/SlotRepository';

export class GetSlotSummaryUseCase {
  constructor(private repo: SlotRepository) {}
  execute() {
    return this.repo.getSummary();
  }
}